import React from 'react'
import CabDetails from '../Home/CabDetails'
import CarList from './CarList'

const IndexListPage = () => {

  return (
    <div style={{ fontFamily: 'Lato, sans-serif' }}>
      <CarList />
    </div>
  )
}

export default IndexListPage
